export default __webpack_public_path__ + "static/media/timetrap-logo.fe03361f.svg";